export default "__VITE_ASSET__BU9QCmHV__";